<template>
  <div>
    <v-simple-table>
      <thead>
      <tr>
        <th>Código</th>
        <th>Data compra</th>
        <th>Total</th>
        <th>Obs. Interna</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="link in notaFiscal.notaFiscalCompraLinks" :key="link.id">
        <td>{{ codigoCompra(link.compra) }}</td>
        <td>{{ link.compra.dataCompra | date }}</td>
        <td>{{ link.compra.total | currency }}</td>
        <td>
          <px-show-large-text :large-text="link.observacaoInterna"/>
        </td>
        <td>
          <px-compra-detalhes-dialog-view :compra-id="link.compra.id"/>
        </td>
      </tr>
      </tbody>
    </v-simple-table>
    </div>
</template>

<script>
export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    codigoCompra() {
      return compra => (compra.codigoInterno ? `${compra.codigoInterno} / ${compra.id}` : compra.id);
    },
  },
  components: {
    pxCompraDetalhesDialogView: () => import('@/modules/compra/detalhes/CompraDetalhesDialogView.vue'),
  },
};
</script>
